import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { container, sectionPad, label, btnOutlineNavy } from "@/lib/ui";
import { SERVICES } from "@/data/services";
import { ServiceCard } from "@/components/ServiceCard";

export function ServicesSection({ limit = 8 }) {
  const items = limit ? SERVICES.slice(0, limit) : SERVICES;
  return (
    <section className={`${sectionPad} bg-neutralbg`} data-testid="services-section">
      <div className={container}>
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6">
          <div className="max-w-2xl">
            <span className={label}>Our Services</span>
            <h2 className="mt-3 font-heading text-3xl lg:text-4xl font-bold tracking-tight text-navy">
              Residential cleaning for every need
            </h2>
            <p className="mt-4 text-gray-600 leading-relaxed">
              From regular upkeep to detailed deep cleans and end-of-lease, we've got your Melbourne home covered.
            </p>
          </div>
          <Link to="/services" className={`${btnOutlineNavy} shrink-0`} data-testid="services-view-all">
            View all services <ArrowRight className="w-4 h-4" />
          </Link>
        </div>

        <div className="mt-12 grid gap-6 sm:grid-cols-2 lg:grid-cols-4">
          {items.map((s, i) => (
            <ServiceCard key={s.slug} service={s} index={i} />
          ))}
        </div>
      </div>
    </section>
  );
}
